import { Alert } from '@energybox/react-ui-library/dist/icons';
import { IncidentStatus } from '@energybox/react-ui-library/dist/types';
import equals from 'ramda/src/equals';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIncidentStatusFilter } from '../actions/filters';
import { ApplicationState } from '../reducers';
import { calculateEnergyCost } from '../utils/sop';

const useIncidentStatusFilter = () => {
  const dispatch = useDispatch();

  const selectedIncidentStatusFilters = useSelector<
    ApplicationState,
    IncidentStatus[]
  >(({ filters }) => {
    return filters.incidentStatuses;
  }, equals);

  let isActiveIncidentStatus = useSelector(
    ({ incidents }: ApplicationState) => incidents.isActiveIncident
  );

  useEffect(() => {
    if (isActiveIncidentStatus) {
      const displayedActiveFilter = Object.values(IncidentStatus).filter(
        (p) => p !== IncidentStatus.RESOLVED
      );
      setFilter(displayedActiveFilter);
    } else {
      selectedIncidentStatusFilters.length = 0;
      setFilter([]);
    }
  }, []);

  const setFilter = useCallback(
    (newStatus: IncidentStatus[]) => {
      dispatch(setIncidentStatusFilter(newStatus));
    },
    [dispatch]
  );

  const resetFilter = useCallback(() => {
    return dispatch(setIncidentStatusFilter([]));
  }, [dispatch]);

  const isIncidentStatusFilterActive =
    selectedIncidentStatusFilters.length > 0 &&
    selectedIncidentStatusFilters.length < Object.keys(IncidentStatus).length;

  return {
    setFilter,
    resetFilter,
    selectedIncidentStatusFilters,
    isIncidentStatusFilterActive,
  };
};

export default useIncidentStatusFilter;
